import React from "react";
import { View, Text, Image, ScrollView } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import ImageComponent from "../../ImageComponent";

interface ActivityItem {
  username: string;
  profilePicture?: string;
  activity: string;
  time: string;
}

interface OpponentActivityProps {
  activities: ActivityItem[];
  isLoading?: boolean;
  isMobile?: boolean;
}

const OpponentActivity: React.FC<OpponentActivityProps> = ({
  activities,
  isLoading = false,
  isMobile = false,
}) => {
  if (isLoading) {
    return (
      <View>
        <Text
          style={[
            AppFontStyle.BOLD_ANYBODY_18,
            { color: "#FFFFFF", marginBottom: 12 },
          ]}
        >
          Event Activity
        </Text>
        <LinearGradient
          colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
          start={[0, 0]}
          end={[1, 1]}
          style={{
            padding: 9,
            flexDirection: "column",
            alignItems: "center",
            gap: 12,
            alignSelf: "stretch",
            borderRadius: 8,
            borderWidth: 0.8,
            borderColor: "#374151",
            minHeight: 200,
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              color: "rgba(255, 255, 255, 0.60)",
              fontSize: 14,
              fontWeight: "400",
            }}
          >
            Loading...
          </Text>
        </LinearGradient>
      </View>
    );
  }

  return (
    <View style={{ flex: 1 }}>
      <Text
        style={[
          AppFontStyle.BOLD_ANYBODY_18,
          { color: "#FFFFFF", marginBottom: 12 },
        ]}
      >
        Event Activity
      </Text>
      <LinearGradient
        colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
        start={[0, 0]}
        end={[1, 1]}
        style={{
          flex: isMobile ? undefined : 1,
          height: isMobile ? 180 : undefined,
          padding: 9,
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
          alignSelf: "stretch",
          borderRadius: 8,
          borderWidth: 0.8,
          borderColor: "#374151",
        }}
      >
        {activities.length === 0 ? (
          <View style={{ paddingVertical: 30 }}>
            <Text
              style={{
                color: "rgba(255, 255, 255, 0.60)",
                fontSize: 14,
                fontWeight: "400",
                textAlign: "center",
              }}
            >
              No activity yet
            </Text>
          </View>
        ) : (
          <ScrollView
            style={{ width: "100%", flex: 1 }}
            showsVerticalScrollIndicator={false}
          >
            {activities.map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  paddingVertical: 8,
                  paddingHorizontal: 6,
                  gap: 12,
                  width: "100%",
                }}
              >
                {/* Profile Picture */}
                <View
                  style={{
                    width: 35,
                    height: 35,
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: 17.5,
                    overflow: "hidden",
                    backgroundColor: "#604e74",
                  }}
                >
                  {item.profilePicture ? (
                    <ImageComponent
                      url={item.profilePicture}
                      style={{
                        width: 35,
                        height: 35,
                        resizeMode: "cover",
                      }}
                    />
                  ) : (
                    <View
                      style={{
                        width: 35,
                        height: 35,
                        backgroundColor: "#604e74",
                      }}
                    />
                  )}
                </View>

                {/* Activity Info */}
                <View style={{ flex: 1 }}>
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_14,
                      { color: "#FFFFFF" },
                    ]}
                  >
                    {item.username}
                  </Text>
                  <Text
                    style={{
                      color: "rgba(255, 255, 255, 0.60)",
                      fontSize: 14,
                      fontWeight: "400",
                      lineHeight: 16.17,
                      marginTop: 2,
                    }}
                  >
                    {item.activity}
                  </Text>
                </View>

                {/* Time */}
                <Text
                  style={{
                    color: "rgba(255, 255, 255, 0.60)",
                    fontSize: 12,
                    fontWeight: "400",
                    lineHeight: 13.86,
                  }}
                >
                  {item.time}
                </Text>
              </View>
            ))}
          </ScrollView>
        )}
      </LinearGradient>
    </View>
  );
};

export default OpponentActivity;
